<template>
  <div id="facecare-terms-of-use-view">
    <header class="term-header">
      <div class="term-title-container">
        <div class="term-title">{{ $t("termsOfUse.title") }}</div>
      </div>
      <div class="app-container">
        <div class="app-icon-container">
          <img
            :src="appIcon"
            class="app-icon"
            alt="アプリアイコン"
            @load="visibleContents()"
          />
        </div>
        <div class="app-info-container">
          <div class="app-name">{{ appName }}</div>
          <div class="app-copyright">{{ appCopyright }}</div>
        </div>
      </div>
    </header>

    <component :is="FacecareTermsOfUse" id="license-article" />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import appIcon from "../../assets/images/terms-of-use/facecare_app_icon.png";
import store from "@/utils/store";

export default {
  components: {},
  data() {
    return {
      appIcon,
      appName: "with Panasonic Beauty",
      appCopyright: "©Panasonic Corporation",
    };
  },
  computed: {
    FacecareTermsOfUse() {
      return defineAsyncComponent(() =>
        import(
          `../../components/terms-of-use/FacecareTermsOfUseText_${store.currentLocale.value}.vue`
        ),
      );
    },
  },
  mounted() {},
  created() {
    /*
    ローカルテスト用URL
    http://localhost:8080/#/withpb-terms-of-use
    */
  },
  methods: {
    visibleContents() {
      document
        .getElementById("facecare-terms-of-use-view")
        .classList.remove("visibility-hidden");
    },
  },
};
</script>

<style scoped>
:root {
  --header-title-height: 42px;
}

.term-header {
  box-sizing: border-box;
  padding: 0;
  padding: 16px;
  height: calc(var(--header-height) + var(--header-title-height));
  width: 100%;
}

.term-title-container {
  height: var(--header-title-height);
  width: 100%;
}

.term-title {
  height: 100%;
  text-align: center;
  font: normal normal normal 18px/26px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000e6;
  opacity: 1;
}

.app-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.app-icon-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: auto;
}
.app-icon {
  height: 84px;
  width: 84px;
  justify-content: center;
}

.app-info-container {
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  text-align: left;
}
.app-name {
  font: normal normal 500 16px/24px Noto Sans JP;
  letter-spacing: -0.38px;
  color: #000000e6;
  padding: 9.5px 0 4px 0;
}
.app-copyright {
  text-align: left;
  font: normal normal 400 10px/15px Noto Sans JP;
  letter-spacing: -0.24px;
  color: #00000099;
}

#license-article {
  box-sizing: border-box;
  padding-left: 16px;
  padding-right: 16px;
  /* 半角英数字を折り返す */
  word-wrap: break-word;
  overflow-wrap: break-word;
  background-color: #ffffff;
}
</style>
